import { render, staticRenderFns } from "./holidayHot.vue?vue&type=template&id=e2ce5176&scoped=true"
import script from "./holidayHot.vue?vue&type=script&lang=js"
export * from "./holidayHot.vue?vue&type=script&lang=js"
import style0 from "./holidayHot.vue?vue&type=style&index=0&id=e2ce5176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce5176",
  null
  
)

export default component.exports